import React, { useEffect, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { usePrevious } from '../../helpers/useReadStateSuccess';
// import { LightboxWrapper } from '../LightBox/logics/LightboxWrapper';
import { DeleteButton } from './Components/DeleteButton';
import { DragNDropUpload } from './Components/DragNDropUpload';
import { UploadFileManager } from './Components/UploadFileManager';
import { UploadLightboxProvider } from './context';
import { Styled } from './style';

export function BukkuUpload({
    //antd
    onChange,
    // parent
    fileTypeFilter, disabled,
    overrideUploadProps,
    openFileManagerOnClick = true,
    acceptedMimes,
    initialFileUrl,
    // onUpload = () => {},
}) {
    const [fileUrl, setFileUrl] = useState(initialFileUrl || null);
    const [componentFile, setComponentFile] = useState(null);
    const [isFileSelectVisible, setIsFileSelectVisible] = useState(false);
    const [uploading, setUploading] = useState(false); // to handle multiple components but only single redux file state (eg: in signature)
    const lightboxRef = useRef(null);

    const selector = state => ({
        readFileState: state.File.readFileState,
        file: state.File.file,
    });
    const {readFileState, file} = useSelector(selector, shallowEqual);

    const prevReadFileState = usePrevious(readFileState);
    const prevInitialFileUrl = usePrevious(initialFileUrl);
    // console.log('aaa BukkuUpload', {uploading, readFileState, file, fileUrl});

    // onFileChange - when upload or select new file (drag n drop // FileManager)
    useEffect(() => {
        if (prevInitialFileUrl !== initialFileUrl) {
            setFileUrl(initialFileUrl);
            setComponentFile({
                file: {url: initialFileUrl},
                id: null,
            });
        }

        if (
            uploading &&
            readFileState === 'success' &&
            (prevReadFileState === false || prevReadFileState === 'request')
        ) {
            // onUpload({ file });
            onChange(file.id);
            setFileUrl(file.url);
            setUploading(false);
            setIsFileSelectVisible(false);
            setComponentFile({file, id: file.id});
        }
    }, [
        prevReadFileState, readFileState,
        prevInitialFileUrl, initialFileUrl,
        file, uploading, onChange,
    ]);

    const contextValues = {
        states: {
            fileUrl,
            isFileSelectVisible,
            uploading,
            componentFile,
        },
        setStates: {
            setFileUrl,
            setIsFileSelectVisible,
            setUploading,
            setComponentFile,
        },
        props: {
            //antd
            onChange,
            // parent
            fileTypeFilter,
            disabled,
            overrideUploadProps,
            openFileManagerOnClick,
            acceptedMimes,
            initialFileUrl,
            // onUpload,
        },
        lightboxRef,
    };

    return (
        <UploadLightboxProvider value={contextValues}>
            <Styled>
                <DeleteButton />

                {/* Upload for drag-n-drop + View Lightbox Action + Open FileManager Action */}
                <DragNDropUpload />

                {/* Lightbox - hidden until clicking on DragNDropUpload */}
                {/* <LightboxWrapper
                    ref={lightboxRef}
                    dataSourceMode="children"
                    hideListDisplay
                >
                    <img src={fileUrl} alt="" />
                </LightboxWrapper> */}

                {/* File Manager */}
                <UploadFileManager />
            </Styled>
        </UploadLightboxProvider>
    );
}
